import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import employee from '../class/employee.js';
import production from '../class/production.js';
import { formatRpcError } from '../class/jrpc20WSClient';
import { isNewVersionAvailable } from '../class/appVersion';
import swal from 'sweetalert';
import useKeepInputFocus from '../hooks/useKeepInputFocus';
import "../styles/LoginPage.css"



function Login() {
    const [numeroAddetto, setNumeroAddetto] = useState('');
    const [numeroOrdine, setNumeroOrdine] = useState('');
    const [ordineAttivo, setOrdineAttivo] = useState(false);

    const navigate = useNavigate();

    const inputAddettoRef = useRef(null);
    const inputOrdineRef = useRef(null);

    // Login col lettore di codici a barre: il focus resta sempre sul campo da scansionare
    useKeepInputFocus(ordineAttivo ? inputOrdineRef : inputAddettoRef);

    // Primo step: badge. Il backend risolve la qualifica dal contratto attivo:
    // 3 = Magazzinieri -> sezione magazzino; 0/1/2 -> si abilita il campo ordine.
    const handleAddettoKeyDown = async (event) => {
        if (event.key === 'Enter' && numeroAddetto.trim() !== '') {
            // Rilascio nuovo: si ricarica il portale prima del login. Qui e non all'apertura del login, dove
            // potrebbe essere ancora in corso la stampa del foglio pallet dell'operatore precedente.
            if (await isNewVersionAvailable()) {
                swal({ title: "Portale aggiornato", text: "Ripassa il badge.", icon: "info", buttons: false });
                setTimeout(() => window.location.reload(), 1500);
                return;
            }

            const loginWS = new employee();
            loginWS.authenticateBadge({ employee_number: numeroAddetto }).then((call_data) => {
                if (call_data.qualifica === 3) {
                    navigate('/orders');
                } else {
                    setOrdineAttivo(true);
                    setTimeout(() => inputOrdineRef.current?.focus(), 0);
                }
            }).catch((error) => {
                swal("Errore", formatRpcError(error), "error");
                setNumeroAddetto('');
                setTimeout(() => inputAddettoRef.current?.focus(), 0);
            });
        }
    };

    const handleOrdineKeyDown = (event) => {
        if (event.key === 'Enter' && numeroOrdine.trim() !== '') {
            const formData = {
                employee_number: numeroAddetto,
                order_number: numeroOrdine,
            };

            const loginWS = new employee();
            loginWS.authenticate(formData).then(async (call_data) => {
                if (call_data.autocontrollo === "1") {
                    navigate(`/order-details/${call_data.order_uuid}`);
                } else {
                    const confirm = await swal({
                        title: "Autocontrollo effettuato?",
                        text: "Hai eseguito l'autocontrollo sull’ordine?",
                        icon: "info",
                        buttons: ["No", "Sì, continua"],
                        dangerMode: true,
                    });

                    if (confirm) {
                        const productionWS = new production();
                        productionWS.confirmAutocontrollo({ order_uuid: call_data.order_uuid }).then(() => {
                            navigate(`/order-details/${call_data.order_uuid}`);
                        }).catch((error) => {
                            swal("Errore", formatRpcError(error), "error");
                            navigate('/');
                            window.location.reload();

                        });
                    } else {
                        // Autocontrollo bloccante: senza conferma non si procede, l'ordine resta invariato
                        await swal("Autocontrollo non effettuato", "Esegui l'autocontrollo prima di procedere con l'ordine.", "warning");
                        new employee().logout();
                        navigate('/');
                        window.location.reload();
                    }
                }

            }).catch((error) => {
                swal("Errore", formatRpcError(error), "error");
            });
        }
    };

    useEffect(() => {
        // Il magazzino mantiene la sessione: se il token e' ancora valido e la
        // qualifica e' Magazzinieri si salta il login. La produzione ri-scansiona
        // sempre il badge (auto-logout dopo ogni registrazione).
        const user_obj = new employee();
        user_obj.isLogged().then(({ qualifica }) => {
            if (qualifica === 3) {
                navigate('/orders');
            }
        }).catch(() => {
            // non loggato: resta sul login
        });

        if (inputAddettoRef.current) {
            inputAddettoRef.current.focus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="login-container">
            <form className='form-login' onSubmit={(e) => e.preventDefault()}>
                <div>
                    <h2 className='login-title' >Log In</h2>
                </div>
                <div className='login-form'>
                    <div className='login-form-block'>
                        <label htmlFor="numeroAddetto">N. Addetto:</label>
                        <input
                            type="text"
                            id="numeroAddetto"
                            value={numeroAddetto}
                            onChange={(e) => setNumeroAddetto(e.target.value)}
                            onKeyDown={handleAddettoKeyDown}
                            className='login-item'
                            autoComplete="numeroAddetto"
                            placeholder="Scansiona il badge"
                            ref={inputAddettoRef}
                            required
                        />

                    </div>
                    {ordineAttivo && (
                        <div className='login-form-block'>
                            <label htmlFor="numeroOrdine">N. Ordine:</label>
                            <input
                                type="text"
                                id="numeroOrdine"
                                value={numeroOrdine}
                                onChange={(e) => setNumeroOrdine(e.target.value)}
                                onKeyDown={handleOrdineKeyDown}
                                className='login-item'
                                ref={inputOrdineRef}
                                placeholder="Inserisci il numero dell'ordine"
                            />
                        </div>
                    )}
                </div>
            </form>
        </div>
    )
}
export default Login;
